export function _debounce(func, delay) {
  let timerId
  return function (...args) {
    clearTimeout(timerId)
    timerId = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export function _throttle(callback, delay) {
  let previousCall = new Date().getTime()
  return function () {
    const time = new Date().getTime()

    // 如果距离上一次函数调用的时间已经超过给定的时间量delay，那么执行函数回调
    if (time - previousCall >= delay) {
      previousCall = time
      callback.apply(this, arguments)
    }
  }
}
